import React, { useState, useEffect } from 'react';
import githubEn from '../assets/github_engraved.png';
import go from '../assets/go.png';
import images from './buildImages';

const ProjectList = ({info}) => {
  const [thumbImg, setThumbImg] = useState(null);
  
  // 1. Make isMobile a state variable so React tracks it
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // 2. Add a resize listener so the component updates dynamically
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleThumb = (e) => {
    let tileId = e.target.id;
    let thumb = tileId ? images[tileId] : null;
    setThumbImg(thumb);
  }

  const clearThumb = () => {
    setThumbImg(null);
  }

  let colors = ["#3FDE9A","#FA2D57","#FD9900","#167AFF","#000000","#FFFFFF","#FDCC01"];
  
  return info.map((el, i) => {
    const currColor = colors[Math.round(i % colors.length)];
    const tintedCurrColor = `${currColor}80`;
    const currThumbnail = images[i];

    return ((i !== 4)
      ? <div key={i} className="wrapper">
          <div className="gray-effect"
                onMouseEnter={toggleThumb}
                onMouseLeave={clearThumb}
                id={i}>
            <div className="links">
              { el.liveUrl ? <a id={i} href={el.liveUrl} target="_blank" rel="noopener noreferrer"><img src={go} alt="source" /></a> : null }
              <a id={i} href={el.gitUrl} target="_blank" rel="noopener noreferrer"><img src={githubEn} alt="source" /></a>
            </div>
          </div>
          
          <div
            className="project-item"
            style={{
              background: isMobile && currThumbnail 
                ? `linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), linear-gradient(${tintedCurrColor}, ${tintedCurrColor}), url(${currThumbnail}) no-repeat center center/cover` 
                : `${currColor}`
            }}
          >
            <div 
              style={{
                background: isMobile ? "rgba(255, 255, 255, 0.1)" : "transparent",
                padding: isMobile ? "0px" : "0",
                borderRadius: "0px",
                backdropFilter: isMobile ? "blur(6px)" : "none",
                WebkitBackdropFilter: isMobile ? "blur(6px)" : "none", // For Safari
              }}
            >
              <h3>{el.title}</h3>
              <p id="project">{el.description}</p>
            </div>
          </div>
        </div>
      : <div key={i} className="thumbnail" style={{background: thumbImg && !isMobile ? `url(${thumbImg}) no-repeat center center/cover` : null}}>
          {/* Optional: Hide the central thumbnail on mobile entirely */}
          {/* {thumbImg && !isMobile ? <img src={thumbImg} alt="thumbnail"/> : null} */}
        </div>
    );
  });
}

export default ProjectList;